import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Flex"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "flex"
    }}>{`Flex`}</h1>
    <p>{`Use the `}<inlineCode parentName="p">{`Flex`}</inlineCode>{` component to create flexbox layouts.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Flex } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex>
  <Box p={2} bg="primary" sx={{ flex: '1 1 auto' }}>
    Flex
  </Box>
  <Box p={2} bg="muted">
    Box
  </Box>
</Flex>
`}</code></pre>
    <Note mdxType="Note">
      <p>{`The `}<inlineCode parentName="p">{`Flex`}</inlineCode>{` component is identical to the `}<inlineCode parentName="p">{`Box`}</inlineCode>{` component, but with `}<inlineCode parentName="p">{`display: flex`}</inlineCode>{` set.
If you need to alter the `}<inlineCode parentName="p">{`display`}</inlineCode>{` property, use the `}<inlineCode parentName="p">{`Box`}</inlineCode>{` component instead.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      